/** Zentrale API-Basis-URL. Lokal immer same-origin (/v2 via setupProxy), kein CORS. */
export function getApiBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return '/';
  }
  const url = process.env.REACT_APP_API_URL || 'https://api.firecore.ch/';
  return url.endsWith('/') ? url : `${url}/`;
}
